import { render, staticRenderFns } from "./SystemQuickMenu.vue?vue&type=template&id=ce0bbc56"
import script from "./SystemQuickMenu.ts?vue&type=script&lang=ts&external"
export * from "./SystemQuickMenu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports